import Note from '__core/shared/model/note/Note';
import NoteAttribute from '__core/shared/model/note/NoteAttribute';
import stNotesListItem from './notesListItem.component';
import stNotesList from './notesList.component';
import stNoteEdit from './noteEdit.component';
import stNoteAddToTicket from './noteAddToTicket.component';
import stNoteAdd from './noteAdd.component';

export default angular
  .module('st.Note', ['st.Core', 'angular-cache'])
  .factory('Note', () => Note)
  .factory('NoteAttribute', () => NoteAttribute)
  .service('noteService', (Note, dataService) => ({
    createNote: (doc) => dataService.createDocument(Note, doc),
    readNote: (doc) => dataService.readDocument(Note, doc),
    updateNote: (doc) => dataService.updateDocument(Note, doc),
    deleteNote: (doc) => dataService.deleteDocument(Note, doc)
  }))
  .component('stNotesListItem', stNotesListItem)
  .component('stNotesList', stNotesList)
  .component('stNoteEdit', stNoteEdit)
  .component('stNoteAddToTicket', stNoteAddToTicket)
  .component('stNoteAdd', stNoteAdd)
  .service('notesService', ($http, $rootScope, CacheFactory, dataService, Note, NOTE) => {
    let cache;
    if (!CacheFactory.get(NOTE.CACHE.NAME)) {
      cache = CacheFactory(NOTE.CACHE.NAME, NOTE.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || NOTE.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailablePerContact: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getAvailablePerContact'),
          params?.ignoreCache === true,
          Note.build,
          $http.get,
          NOTE.API.AVAILABLE_PER_CONTACT,
          { params }
        ),
      getSpecific: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getSpecific'),
          params?.ignoreCache === true,
          Note.build,
          $http.post,
          NOTE.API.SPECIFIC,
          { params }
        ),
      getTop: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getTop'),
          params?.ignoreCache === true,
          Note.build,
          $http.post,
          NOTE.API.TOP,
          { params }
        )
    };
  })
  .constant('NOTE', {
    API: {
      AVAILABLE_PER_CONTACT: '/api/v1/notes/available-per-contact/',
      SPECIFIC: '/api/v1/notes/specific/',
      TOP: '/api/v1/notes/top/',
      UPLOAD: '/api/v1/note/upload/',
      DOWNLOAD: '/api/v1/note/download/',
      DOWNLOAD_PDF: '/api/v1/note/download/pdf/',
      DOWNLOAD_VIDEO: '/api/v1/note/download-video/'
    },
    CACHE: {
      NAME: 'notesCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
